import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Award } from "lucide-react";

export default function AchievementsWidget() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/achievements").then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const { unlocked = [], locked = [], stats = {} } = data;
  const total = unlocked.length + locked.length;

  return (
    <div className="card-soft p-6" data-testid="achievements-widget">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-2xl bg-amber-100 text-amber-700 flex items-center justify-center"><Award className="w-4 h-4" /></div>
          <div>
            <div className="font-display font-bold text-lg leading-none">Achievements</div>
            <div className="text-[11px] text-gray-500">{unlocked.length} / {total} unlocked</div>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2" data-testid="achievements-unlocked">
        {unlocked.map(a => (
          <div key={a.id} className="bg-amber-50 border border-amber-200 rounded-2xl px-3 py-2 flex items-center gap-2">
            <span className="text-lg">{a.emoji}</span>
            <span className="text-xs font-semibold text-amber-900">{a.title}</span>
          </div>
        ))}
      </div>

      {locked.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2 opacity-40" data-testid="achievements-locked">
          {locked.slice(0, 6).map(a => (
            <div key={a.id} className="bg-gray-50 border border-gray-200 rounded-2xl px-3 py-2 flex items-center gap-2">
              <span className="text-lg grayscale">{a.emoji}</span>
              <span className="text-xs font-semibold text-gray-500">{a.title}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
